import { COLOR } from 'app-v2/design-tokens'
import React from 'react'
import type { Icon } from 'shared/utils'

export const Light = ({
    color = COLOR.PRIMARY,
    size = 24,
    className = 'light',
    ...otherProps
}: Icon) => (
    <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 24 24"
        {...otherProps}>
        <path
            d="M12 0C5.38 0 0 5.38 0 12c0 2.513.794 4.83 2.116 6.759L.054 23.187a.571.571 0 00.776.75l4.26-2.125c.269.218.568.48.91.68a.572.572 0 00.571-.992c-.246-.144-.724-.555-1.089-.821a.571.571 0 00-.598-.054l-3.098 1.554 1.49-3.215a.571.571 0 00-.053-.58A10.794 10.794 0 011.143 12 10.848 10.848 0 0112 1.143 10.848 10.848 0 0122.857 12 10.848 10.848 0 0112 22.857c-1.22 0-2.428-.163-3.527-.544a.572.572 0 00-.375 1.08c1.25.433 2.583.607 3.902.607 6.62 0 12-5.38 12-12S18.62 0 12 0zm0 3.429c-3.147 0-5.714 2.543-5.714 5.67 0 1.818.683 2.822 1.259 3.597.576.775 1.026 1.307 1.026 2.733 0 .315.256.571.572.571h5.714a.571.571 0 00.572-.571c0-1.426.45-1.958 1.026-2.733.576-.775 1.26-1.78 1.26-3.598 0-3.126-2.568-5.67-5.715-5.67zm0 1.142c2.535 0 4.571 2.024 4.571 4.527 0 1.561-.46 2.157-1.026 2.92-.497.668-1.066 1.506-1.206 2.84h-1.768v-4.385a1.729 1.729 0 001.143-1.616c0-.94-.774-1.714-1.714-1.714s-1.714.774-1.714 1.714c0 .74.48 1.378 1.143 1.616v4.384H9.66c-.14-1.333-.71-2.171-1.206-2.84-.567-.762-1.026-1.358-1.026-2.919 0-2.503 2.036-4.527 4.571-4.527zm0 3.715c.322 0 .571.249.571.571 0 .323-.249.572-.571.572a.563.563 0 01-.571-.572c0-.322.249-.571.571-.571zm-2.482 8.857a.572.572 0 10.053 1.143h4.858a.571.571 0 100-1.143H9.518zm1.143 2.286a.572.572 0 10.053 1.142h2.572a.571.571 0 100-1.142H10.66z"
            fill={color}
            fillRule="nonzero"
        />
    </svg>
)
